export let dataProps = {
    id: 0,
    trial_type: '',
    remarks: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringTrialType/properties.js